/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.safelink.defs'

export { $nsid }

/** An event for URL safety decisions */
type Event = {
  $type?: 'tools.ozone.safelink.defs#event'

  /**
   * Auto-incrementing row ID
   */
  id: number
  eventType: EventType

  /**
   * The URL that this rule applies to
   */
  url: string
  pattern: PatternType
  action: ActionType
  reason: ReasonType

  /**
   * DID of the user who created this rule
   */
  createdBy: l.DidString
  createdAt: l.DatetimeString

  /**
   * Optional comment about the decision
   */
  comment?: string
}

export type { Event }

/** An event for URL safety decisions */
const event = l.typedObject<Event>(
  $nsid,
  'event',
  l.object({
    id: l.integer(),
    eventType: l.ref<EventType>((() => eventType) as any),
    url: l.string(),
    pattern: l.ref<PatternType>((() => patternType) as any),
    action: l.ref<ActionType>((() => actionType) as any),
    reason: l.ref<ReasonType>((() => reasonType) as any),
    createdBy: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
    comment: l.optional(l.string()),
  }),
)

export { event }

type EventType = 'addRule' | 'updateRule' | 'removeRule' | l.UnknownString

export type { EventType }

const eventType = l.string<{
  knownValues: ['addRule', 'updateRule', 'removeRule']
}>()

export { eventType }

type PatternType = 'domain' | 'url' | l.UnknownString

export type { PatternType }

const patternType = l.string<{ knownValues: ['domain', 'url'] }>()

export { patternType }

type ActionType = 'block' | 'warn' | 'whitelist' | l.UnknownString

export type { ActionType }

const actionType = l.string<{ knownValues: ['block', 'warn', 'whitelist'] }>()

export { actionType }

type ReasonType = 'csam' | 'spam' | 'phishing' | 'none' | l.UnknownString

export type { ReasonType }

const reasonType = l.string<{
  knownValues: ['csam', 'spam', 'phishing', 'none']
}>()

export { reasonType }

/** Input for creating a URL safety rule */
type UrlRule = {
  $type?: 'tools.ozone.safelink.defs#urlRule'

  /**
   * The URL or domain to apply the rule to
   */
  url: string
  pattern: PatternType
  action: ActionType
  reason: ReasonType

  /**
   * Optional comment about the decision
   */
  comment?: string

  /**
   * DID of the user added the rule.
   */
  createdBy: l.DidString

  /**
   * Timestamp when the rule was created
   */
  createdAt: l.DatetimeString

  /**
   * Timestamp when the rule was last updated
   */
  updatedAt: l.DatetimeString
}

export type { UrlRule }

/** Input for creating a URL safety rule */
const urlRule = l.typedObject<UrlRule>(
  $nsid,
  'urlRule',
  l.object({
    url: l.string(),
    pattern: l.ref<PatternType>((() => patternType) as any),
    action: l.ref<ActionType>((() => actionType) as any),
    reason: l.ref<ReasonType>((() => reasonType) as any),
    comment: l.optional(l.string()),
    createdBy: l.string({ format: 'did' }),
    createdAt: l.string({ format: 'datetime' }),
    updatedAt: l.string({ format: 'datetime' }),
  }),
)

export { urlRule }
